<template>
    <v-container>
        <div style="background-color: rgb(230, 233, 242); padding-left: 20px; padding-right: 20px; padding-bottom: 15px;">
            <!-- <h1>ESPECIES</h1> -->
            <h2 style="font-size: 2.5rem; color: rgb(0, 30, 67)">Especies</h2>
            <div>
                <v-row>
                    <v-col cols="12" md="12" lg="12">
                        En esta sección encontrarás un listado de fichas detalladas de diversas especies de maderas. Cada ficha incluye información relevante, como: 
                        <li>Nombre común, científico y comercial, familia</li>
                        <li>Color, olor y sabor</li>
                        <li>Parénquima, poros, radios, textura y más</li>
                        <br>
                        Explora cada ficha para conocer las características únicas de cada especie.
                    </v-col>
                </v-row>
            </div>
        </div>
        <br>
        <!--REGISTRAR NUEVO O ACTUALIZAR-->
        <div>
            <v-dialog v-model="dialog" max-width="80%">
                <template v-slot:activator="{ on }">
                    <v-row>
                        <v-col cols="12" md="12" lg="2">
                            <a href="#formContent" style="text-decoration: none;">
                                <v-btn 
                                    style="background-color: rgb(0, 124, 186); color: white;" v-if="(rolOid === 1 || rolOid === 2)" dark class="mb-2" v-on="on" @click="nueva">
                                    Agregar Especie
                                </v-btn>
                            </a>
                        </v-col>
                    </v-row> 
                </template>                            
                <v-card id="formContent">
                    <v-card-title>
                        <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 sm12 md12>
                                    <!-- Información General -->
                                    <v-card class="pa-4 mb-4" outlined style="border-color: rgb(0, 124, 186);">
                                        <h5 class="text-center blue--text">Información general</h5>
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <v-text-field v-model="dato.n_comun" label="Nombre Común" class="rounded" :disabled="!isNew"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <v-text-field v-model="dato.n_cientifico" label="Nombre Cientifico" class="rounded"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <v-text-field v-model="dato.autor" label="Autor" class="rounded"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <v-text-field v-model="dato.familia" label="Familia" class="rounded"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <v-text-field v-model="dato.n_comercial" label="Nombre comercial internacional" class="rounded"></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-textarea v-model="dato.n_otro" label="Otros nombres comunes" class="rounded"></v-textarea>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-textarea v-model="dato.n_opciones" label="Opciones de nombre para búsqueda" class="rounded"></v-textarea>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-textarea v-model="dato.sinonimo" label="Sinónimos botánicos" class="rounded"></v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                    <!-- Caracteristicas Generales -->
                                    <v-card class="pa-4 mb-4" outlined style="border-color: rgb(0, 124, 186);">
                                        <h5 class="text-center blue--text">Características generales</h5>
                                        <v-row>
                                            <v-col cols="12" md="7">
                                                <v-textarea v-model="dato.color" label="Color" class="rounded"></v-textarea>
                                            </v-col>
                                            <v-col cols="12" md="5">
                                                <v-textarea v-model="dato.olor" label="Olor" class="rounded"></v-textarea>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-textarea v-model="dato.sabor" label="Sabor" class="rounded"></v-textarea>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-textarea v-model="dato.veteado" label="Veteado" class="rounded"></v-textarea>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-select v-model="dato.texturas" :items="texturas" item-text="titulo" item-value="oid" label="Textura" multiple>
                                                    <template v-slot:label> Textura
                                                        <span style="color: red;">*</span>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                    <!-- Características macroscópicas -->
                                    <v-card class="pa-4 mb-4" outlined style="border-color: rgb(0, 124, 186);">
                                        <h5 class="text-center blue--text">Características macroscópicas</h5>
                                        <v-row>
                                            <v-col cols="12" md="4">
                                                <v-text-field v-model="dato.porosidad" label="Porosidad" class="rounded"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-select v-model="dato.parenquimas" :items="parenquimas" item-text="titulo" item-value="oid" label="Parenquima" multiple>
                                                    <template v-slot:label> Parenquima
                                                        <span style="color: red;">*</span>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-select v-model="dato.poros" :items="poros" item-text="titulo" item-value="oid" label="Poros" multiple>
                                                    <template v-slot:label> Poros
                                                        <span style="color: red;">*</span>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-select v-model="dato.radios" :items="radios" item-text="titulo" item-value="oid" label="Radios" multiple>
                                                    <template v-slot:label> Radios
                                                        <span style="color: red;">*</span>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-select v-model="dato.inclusiones" :items="inclusiones" item-text="titulo" item-value="oid" label="Inclusiones" multiple>
                                                    <template v-slot:label> Inclusiones
                                                        <span style="color: red;">*</span>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                    <!-- Cortes -->
                                    <v-card class="pa-4 mb-4" outlined style="border-color: rgb(0, 124, 186);">
                                        <h5 class="text-center blue--text">Cortes</h5>
                                        <v-row>
                                            <v-col cols="12" md="4">
                                                <v-file-input v-model="dato.Corte1" accept="application/.jpg,.jpeg,.png,.jpg" label="Corte transversal 10x" :rules="[validarR1]" show-size>
                                                    <template v-slot:label> Corte transversal 10x
                                                        <span style="color: red;">*</span>
                                                    </template>
                                                </v-file-input>
                                                <div v-if="dato.Corte1Name" class="mt-2">
                                                    {{ dato.Corte1Name }}
                                                </div>
                                                <div v-else class="mt-2">
                                                    Corte transversal 10x Sin imagen
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-file-input v-model="dato.Corte2" accept="application/.jpg,.jpeg,.png,.jpg" label="Corte transversal 20x" :rules="[validarR1]" show-size>
                                                    <template v-slot:label> Corte transversal 20x
                                                        <span style="color: red;">*</span>
                                                    </template>
                                                </v-file-input>
                                                <div v-if="dato.Corte2Name" class="mt-2">
                                                    {{ dato.Corte2Name }}
                                                </div>
                                                <div v-else class="mt-2">
                                                    Corte transversal 20x Sin imagen
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-file-input v-model="dato.Corte3" accept="application/.jpg,.jpeg,.png,.jpg" label="Corte transversal 10x o 20x (con dibujos de características claves)" :rules="[validarR1]" show-size>
                                                    <template v-slot:label> Corte transversal 10x o 20x (con dibujos de características claves)
                                                        <span style="color: red;">*</span>
                                                    </template>
                                                </v-file-input>
                                                <div v-if="dato.Corte3Name" class="mt-2">
                                                    {{ dato.Corte3Name }}
                                                </div>
                                                <div v-else class="mt-2">
                                                    Corte transversal 10x o 20x (con dibujos de características claves) Sin imagen
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-file-input v-model="dato.Corte4" accept="application/.jpg,.jpeg,.png,.jpg" label="Corte tangencial" :rules="[validarR1]" show-size>
                                                    <template v-slot:label> Corte tangencial
                                                        <span style="color: red;">*</span>
                                                    </template>
                                                </v-file-input>
                                                <div v-if="dato.Corte4Name" class="mt-2">
                                                    {{ dato.Corte4Name }}
                                                </div>
                                                <div v-else class="mt-2">
                                                    Corte tangencial Sin imagen
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-file-input v-model="dato.Corte5" accept="application/.jpg,.jpeg,.png,.jpg" label="Corte radial" :rules="[validarR1]" show-size>
                                                    <template v-slot:label> Corte radial
                                                        <span style="color: red;">*</span>
                                                    </template>
                                                </v-file-input>
                                                <div v-if="dato.Corte5Name" class="mt-2">
                                                    {{ dato.Corte5Name }}
                                                </div>
                                                <div v-else class="mt-2">
                                                    Corte radial Sin imagen
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                    <!-- Otras Características Clave -->
                                    <v-card class="pa-4 mb-4" outlined style="border-color: rgb(0, 124, 186);">
                                        <h5 class="text-center blue--text">Otras Características Clave</h5>
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <v-file-input v-model="dato.Tip1" accept="application/.jpg,.jpeg,.png,.jpg" label="Tip 1" :rules="[validarR1]">
                                                    <template v-slot:label> Características clave 1</template>
                                                </v-file-input>
                                                <div v-if="dato.Tip1Name" class="mt-2">
                                                    {{ dato.Tip1Name }}
                                                </div>
                                                <div v-else class="mt-2">
                                                    Características clave 1 Sin imagen
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-text-field v-model="dato.desc_tip1" label="Descripción características clave 1" class="rounded"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-file-input v-model="dato.Tip2" accept="application/.jpg,.jpeg,.png,.jpg" label="Tip 2" :rules="[validarR1]">
                                                    <template v-slot:label> Características clave 2 </template>
                                                </v-file-input>
                                                <div v-if="dato.Tip2Name" class="mt-2">
                                                    {{ dato.Tip2Name }}
                                                </div>
                                                <div v-else class="mt-2">
                                                    Características clave 2 Sin imagen
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-text-field v-model="dato.desc_tip2" label="Descripción características clave 2" class="rounded"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-file-input v-model="dato.Tip3" accept="application/.jpg,.jpeg,.png,.jpg" label="Tip 3" :rules="[validarR1]">
                                                    <template v-slot:label> Características clave 3 </template>
                                                </v-file-input>
                                                <div v-if="dato.Tip3Name" class="mt-2">
                                                    {{ dato.Tip3Name }}
                                                </div>
                                                <div v-else class="mt-2">
                                                    Características clave 3 Sin imagen
                                                </div>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-text-field v-model="dato.desc_tip3" label="Descripción características clave 3" class="rounded"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                    <!-- Estado -->
                                    <v-card class="pa-4 mb-4" outlined style="border-color: rgb(0, 124, 186);">
                                        <h5 class="text-center blue--text">Estado de conservación</h5>
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <v-radio-group v-model="dato.estado" label="¿La especie se encuentra en algún apéndice CITE?" class="rounded"> <!-- Label agregado en v-radio-group -->
                                                    <v-row>
                                                    <v-col v-for="opcion in ops" :key="opcion.valor" cols="auto">
                                                        <v-radio :label="opcion.texto" :value="opcion.valor"></v-radio>
                                                    </v-col>
                                                    </v-row>
                                                </v-radio-group>
                                            </v-col>
                                            <v-col cols="12" md="7">
                                                <v-textarea v-model="dato.desc_estado" label="Completar según categoría UICN o Apéndice CITE" class="rounded"></v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="cerrar">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="guardar">{{ isNew ? 'Guardar' : 'Actualizar' }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <!--TABLA DE DATOS y FILTROS-->
        <div>
            <!-- FILTRO TEXTO -->
            <v-row>
                <v-col cols="12" lg="12">
                    <v-text-field v-model="search" label="Buscar por nombre (común, cientifico, comercial)" outlined dense hide-details>
                        <template v-slot:append>
                            <div style="color: white; background-color: rgb(0, 124, 186); height: 100%; margin-right: -12px; margin-top: -7px; padding: 10px">
                                <v-icon style="color: white;">search</v-icon>Buscador
                            </div>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <!-- FILTROS -->
            <v-row>
                <v-col cols="12" lg="2">
                    <v-select v-model="FiltroPoros" :items="optionsPoros" item-text="titulo" item-value="oid" label="Filtrar por Poros" outlined dense multiple></v-select>
                </v-col>
                <v-col cols="12" lg="2">
                    <v-select v-model="FiltroParenquima" :items="optionsParenquimas" item-text="titulo" item-value="oid" label="Filtrar por Parénquima" outlined dense multiple></v-select>
                </v-col>
                <v-col cols="12" lg="2">
                    <v-select v-model="FiltroRadios" :items="optionsRadios" item-text="titulo" item-value="oid" label="Filtrar por Radios" outlined dense multiple></v-select>
                </v-col>
                <v-col cols="12" lg="2">
                    <v-select v-model="FiltroTextura" :items="optionsTexturas" item-text="titulo" item-value="oid" label="Filtrar por Textura" outlined dense multiple></v-select>
                </v-col>
                <v-col cols="12" lg="2">
                    <v-select v-model="FiltroInclusiones" :items="optionsInclusiones" item-text="titulo" item-value="oid" label="Filtrar por Inclusiones" outlined dense multiple></v-select>
                </v-col>
                <v-col cols="12" lg="auto" class="d-flex align-center">
                    <v-btn @click="limpiarFiltros" style="background-color: rgb(0, 124, 186); color: white; margin-top: -25px;">
                        Limpiar Filtros
                    </v-btn>
                </v-col>
            </v-row>
            <!-- TABLA -->
            <v-row>
                <v-col cols="12" md="12" lg="12">
                    <h2>Lista de Especies</h2>
                    <v-data-table :items="filtered" item-key="oid">
                        <template v-slot:header>
                            <thead>
                                <tr>
                                    <th class="sticky sticky-left blue--text text-h6">Acciones</th>
                                    <th class="sticky sticky-left-2 blue--text text-h6">Nombre Común</th>
                                    <th class="sticky sticky-left-3 blue--text text-h6">Nombre Científico</th>
                                    <th class="blue--text text-h6" style="min-width: 130px;">Autor</th>
                                    <th class="blue--text text-h6">Familia</th>
                                    <th class="blue--text text-h6">Nombre comercial internacional</th>
                                    <th class="blue--text text-h6" style="min-width: 200px;">Color</th>
                                    <th class="blue--text text-h6">Olor</th>
                                    <th class="blue--text text-h6">Sabor</th>
                                    <th class="blue--text text-h6" style="min-width: 200px;">Veteado</th>
                                    <th class="blue--text text-h6">Porosidad</th>
                                    <th class="blue--text text-h6">Texturas</th>
                                    <th class="blue--text text-h6">Parenquimas</th>
                                    <th class="blue--text text-h6">Poros</th>
                                    <th class="blue--text text-h6">Radios</th>
                                    <th class="blue--text text-h6">Inclusiones</th>
                                </tr>
                            </thead>
                        </template>
                        <!-- Personalización de las filas -->
                        <template v-slot:item="{ item, index }">
                            <tr>
                                <td v-for="(column, colIndex) in ['acciones', 'n_comun', 'n_cientifico', 'autor', 'familia', 'n_comercial', 'color', 'olor', 'sabor', 'veteado', 'porosidad', 'texturas', 'parenquimas', 'poros', 'radios', 'inclusiones']"
                                    :key="colIndex"
                                    :class="[index % 2 === 0 ? 'row-white' : 'row-gray', colIndex === 0 ? 'sticky sticky-left' : '', colIndex === 1 ? 'sticky sticky-left-2' : '', colIndex === 2 ? 'sticky sticky-left-3' : '']">
                                    <!-- Columna de Acciones -->
                                    <template v-if="column === 'acciones'">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-icon small class="mr-2" v-on="on" @click="mostrar(item.oid)">mdivisibility</v-icon>
                                            </template>
                                            <span>Detalle</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-icon v-if="(rolOid === 1 || rolOid === 2)" small class="mr-2" v-on="on" @click="editar(item)">mdiedit</v-icon>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-icon v-if="(rolOid === 1 || rolOid === 2)" small v-on="on" @click="confirmarEliminar(item.oid)">mdidelete</v-icon>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </template>

                                    <!-- Columnas de datos -->
                                    <template v-else-if="column === 'n_comun'">{{ item.n_comun }}</template>
                                    <template v-else-if="column === 'n_cientifico'">{{ item.n_cientifico }}</template>
                                    <template v-else-if="column === 'autor'">{{ item.autor }}</template>
                                    <template v-else-if="column === 'familia'">{{ item.familia }}</template>
                                    <template v-else-if="column === 'n_comercial'">{{ item.n_comercial }}</template>
                                    <template v-else-if="column === 'color'">{{ item.color }}</template>
                                    <template v-else-if="column === 'olor'">{{ item.olor }}</template>
                                    <template v-else-if="column === 'sabor'">{{ item.sabor }}</template>
                                    <template v-else-if="column === 'veteado'">{{ item.veteado }}</template>
                                    <template v-else-if="column === 'porosidad'">{{ item.porosidad }}</template>
                                    <template v-else-if="column === 'texturas'">{{ item.texturas.join(', ') }}</template>
                                    <template v-else-if="column === 'parenquimas'">{{ item.parenquimas.join(', ') }}</template>
                                    <template v-else-if="column === 'poros'">{{ item.poros.join(', ') }}</template>
                                    <template v-else-if="column === 'radios'">{{ item.radios.join(', ') }}</template>
                                    <template v-else-if="column === 'inclusiones'">{{ item.inclusiones.join(', ') }}</template>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </div>
        <div>
            <!-- Diálogo para ver detalle-->
            <v-dialog v-model="dialogdetail" max-width="90%">
                <v-card>
                    <v-card-title class="headline" style="position: relative;">
                        <v-icon @click="cancelarDetalle" style="position: absolute; right: 10px; cursor: pointer;">close</v-icon>
                        <v-icon @click="cancelarDetalle" right>close</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-row>
                                    <!-- Nombre e Imagenes -->
                                    <v-col cols="12" md="12" lg="6">
                                        <v-flex xs12 sm12 md12 fixed>
                                        <h1 class="text-center">{{ dato.n_comun }}</h1><br>
                                        <h1 class="text-center"><em><b>{{ extractedName1 }}</b></em></h1><br><br>              
                                        </v-flex>
                                        <v-flex xs12 sm12 md12>
                                            <div v-if="allImages.length > 0">
                                                <v-carousel hide-delimiters height="600px" cycle class="overlay-carousel">
                                                    <v-carousel-item v-for="(image, index) in allImages" :key="index" class="fade-transition">
                                                        <v-img :src="image.src" :alt="image.alt" aspect-ratio="1.75"></v-img>
                                                        <p style="font-size: 1.5rem; color: rgb(15, 135, 201);padding-left: 15px;"> {{ image.label }}</p>
                                                    </v-carousel-item>
                                                </v-carousel>
                                            </div>
                                            <div v-else>
                                                <p>No hay imágenes para mostrar</p>
                                            </div>
                                            <div v-if="allImagesTips.length > 0">
                                                <v-carousel hide-delimiters height="800px" cycle class="overlay-carousel">
                                                    <v-carousel-item v-for="(image, index) in allImagesTips" :key="index" class="fade-transition">
                                                        <v-img :src="image.src" :alt="image.alt" aspect-ratio="1.75"></v-img>
                                                        <p style="font-size: 1.5rem; color: rgb(15, 135, 201);padding-left: 15px;"> {{ image.label }}</p>
                                                    </v-carousel-item>
                                                </v-carousel>
                                            </div>
                                            <div v-else>
                                                <p>No hay Tips  para mostrar</p>
                                            </div>
                                        </v-flex>
                                    </v-col>
                                    <!-- Detalles de Cards -->
                                    <v-col cols="12" md="12" lg="6">
                                        <details>
                                            <summary>
                                                <p><b>Información General</b></p>
                                            </summary>
                                            <v-row>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Nombre Común<br></b></span>{{ dato.n_comun }}</p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Nombre Cientifico<br></b></span>{{ dato.n_cientifico }}</p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Autor<br></b></span>{{ dato.autor }}</p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Familia<br></b></span>{{ dato.familia }}</p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Nombre Comercial Internacional<br></b></span>{{ dato.n_comercial }}</p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="11">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Otros Nombres Comunes<br></b></span>{{ dato.n_otro }}</p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="11">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Sinónimos botánicos<br></b></span>{{ dato.sinonimo }}</p>
                                                </v-col>
                                            </v-row>
                                        </details>
                                        <details>
                                            <summary>
                                                <p><b>Características</b></p>                                                
                                            </summary>                                    
                                            <v-row>                                                    
                                                <v-col cols="12" md="6" lg="6">
                                                    <p style="padding-left: 15px;"><b>Características macroscópicas</b></p>
                                                    <p style="padding-left: 15px;"><span class="label"><b>Porosidad<br></b></span>{{ dato.porosidad }}</p>
                                                    <h3 style="padding-left: 15px;">Poros</h3>
                                                        <ul style="padding-left: 10%;">
                                                            <li v-for="poro in dato.poros" :key="poro"><p>{{ poro }}</p></li>
                                                        </ul>
                                                    <h3 style="padding-left: 15px;">Parénquimas</h3>
                                                        <ul style="padding-left: 10%;">
                                                            <li v-for="parenquima in dato.parenquimas" :key="parenquima"><p>{{ parenquima }}</p></li>
                                                        </ul>
                                                    <h3 style="padding-left: 15px;">Radios</h3>
                                                        <ul style="padding-left: 10%;">
                                                            <li v-for="radio in dato.radios" :key="radio"><p>{{ radio }}</p></li>
                                                        </ul>
                                                    <h3 style="padding-left: 15px;">Inclusiones</h3>
                                                        <ul style="padding-left: 10%;">
                                                            <li v-for="inclusion in dato.inclusiones" :key="inclusion"><p>{{ inclusion }}</p></li>
                                                        </ul>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="5">
                                                    <p><b>Características generales</b></p>
                                                    <h3>Texturas</h3>
                                                        <ul style="padding-left: 10%;">
                                                            <li v-for="textura in dato.texturas" :key="textura"><p>{{ textura }}</p></li>
                                                        </ul>
                                                    <p><span class="label"><b>Color<br></b></span>{{ dato.color }}</p>
                                                    <p><span class="label"><b>Olor<br></b></span>{{ dato.olor }}</p>
                                                    <p><span class="label"><b>Sabor<br></b></span>{{ dato.sabor }}</p>
                                                    <p><span class="label"><b>Veteado<br></b></span>{{ dato.veteado }}</p>
                                                </v-col>
                                            </v-row>
                                        </details>
                                        <details v-if="(dato.estado === 1)">
                                            <summary>
                                                <p><b>Estado de conservación</b></p>
                                            </summary>
                                            <v-row>
                                                <v-col cols="12" md="6" lg="3">
                                                    <p style="padding-left: 15px;"><strong>¿La especie se encuentra en algún apéndice CITE?</strong> {{ consultarAprobado('estado').texto }}</p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="8">
                                                    <p style="padding-left: 15px;"><span class="label"><b>Completar según categoría UICN o Apéndice CITE<br></b></span>{{ dato.desc_estado }}</p>
                                                </v-col>
                                            </v-row>
                                        </details>
                                        <!--<details v-if="(img_desc_tip1 != null)">
                                            <summary>
                                                <p><b>TIPs</b></p>
                                            </summary>
                                            <v-row>
                                                <v-col cols="12" md="6" lg="1">
                                                    <p><b style="padding-left: 15px;">Tip 1</b></p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="5">
                                                    <v-img :src="images_Tip1" max-width="80%" contain></v-img>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p><span class="label"><b>Descripción Tip 1:<br></b></span>{{ dato.img_desc_tip1 }}</p>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="6" lg="1">
                                                    <p><b style="padding-left: 15px;">Tip 2</b></p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="5">
                                                    <v-img :src="images_Tip2" max-width="80%" contain></v-img>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p><span class="label"><b>Descripción Tip 2:<br></b></span>{{ dato.img_desc_tip2 }}</p>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="6" lg="1">
                                                    <p><b style="padding-left: 15px;">Tip 3</b></p>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="5">
                                                    <v-img :src="images_Tip3" max-width="80%" contain></v-img>
                                                </v-col>
                                                <v-col cols="12" md="6" lg="4">
                                                    <p><span class="label"><b>Descripción Tip 3:<br></b></span>{{ dato.img_desc_tip3 }}</p>
                                                </v-col>
                                            </v-row>
                                        </details>-->
                                    </v-col>
                                </v-row>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="rgb(0, 124, 186)" text @click="cancelarDetalle">Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- Diálogo de confirmación para eliminar -->
            <v-dialog v-model="showConfirmDialog" max-width="35%">
                    <v-card>
                    <v-card-title class="headline">Confirmar la eliminación</v-card-title>
                    <v-card-text>
                        ¿Está segura de que desea eliminar este registro?
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" text @click="eliminar(confirmItemId)">Sí</v-btn>
                        <v-btn color="secondary" text @click="cancelarEliminar">No</v-btn>
                    </v-card-actions>
                    </v-card>
            </v-dialog>

            <!-- Dialogo para Mensaje cargando-->
            <v-dialog v-model="dialog_guardando" max-width="550px"> 
                <v-card>
                    <v-card-title class="headline">Guardando.....</v-card-title>
                </v-card>
            </v-dialog>

            <!-- Mensaje de confirmación-->
            <v-snackbar v-model="guardarExitoso" color="success" top>
                Guardado exitosamente
                <template v-slot:action="{ attrs }">
                    <v-btn color="success" text v-bind="attrs" @click="registroExitoso = false">Cerrar</v-btn>
                </template>
            </v-snackbar>
        </div>
    </v-container>
</template>
<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                datos: [],
                texturas: [],
                poros: [],
                radios: [],
                parenquimas: [],
                inclusiones: [],
                texturasxEspecie: [],
                porosxEspecie: [],
                radiosxEspecie: [],
                parenquimasxEspecie: [],
                inclusionesxEspecie: [],
                dato: {
                    oid: 0,
                    n_comun: '',
                    n_cientifico: '',
                    n_comercial: '',
                    autor: '',
                    n_opciones: '',
                    n_otro: '',
                    sinonimo: '',
                    color: '',
                    olor: "",
                    sabor: "",
                    veteado: "",
                    porosidad: "",
                    familia: "",
                    estado: null,
                    desc_estado: "",
                    images: '',
                    texturas: [], // nuevo campo para las texturas
                    poros: [],
                    radios: [],
                    parenquimas: [],
                    inclusiones: [],                
                    Corte1: null,
                    Corte2: null,
                    Corte3: null,
                    Corte4: null,
                    Corte5: null,
                    Tip1: null,
                    Tip2: null,
                    Tip3: null,
                    desc_tip1: '',
                    desc_tip2: '',
                    desc_tip3: '',
                },
                search: '',
                FiltroTextura: [],
                FiltroParenquima: [],
                FiltroPoros: [],
                FiltroRadios: [],
                FiltroInclusiones: [],
                headers: [
                    { text: 'Acciones', value: 'actions', sortable: false, width: '100px', class: 'blue--text text-h6' },
                    { text: 'Nombre Común', value: 'n_comun', width: '200', class: 'blue--text text-h6' }, 
                    { text: 'Nombre Cientifico', value: 'n_cientifico', width: '220px', class: 'blue--text text-h6' },
                    { text: 'Familia', value: 'familia', width: '150px', class: 'blue--text text-h6' },
                    { text: 'Nombre comercial internacional', value: 'n_comercial', width: '250px', class: 'blue--text text-h6' },
                    { text: 'Color', value: 'color', width: '150px', class: 'blue--text text-h6' },
                    { text: 'Olor', value: 'olor', width: '100px', class: 'blue--text text-h6' },
                    { text: 'Sabor', value: 'sabor', width: '120px', class: 'blue--text text-h6' },
                    { text: 'Veteado', value: 'veteado', width: '150px', class: 'blue--text text-h6' },
                    { text: 'Porosidad', value: 'porosidad', width: '150px', class: 'blue--text text-h6' },
                    { text: 'Texturas', value: 'texturas', width: '130px', class: 'blue--text text-h6' },
                    { text: 'Parenquimas', value: 'parenquimas', width: '190px', class: 'blue--text text-h6' },
                    { text: 'Poros', value: 'poros', width: '150px', class: 'blue--text text-h6' },
                    { text: 'Radios', value: 'radios', width: '150px', class: 'blue--text text-h6' },
                    { text: 'Inclusiones', value: 'inclusiones', width: '160px', class: 'blue--text text-h6' }
                ],
                dialog: false,
                formTitle: '',
                dialogdetail: false,
                showConfirmDialog: false,
                isNew: true,
                dialog_guardando: false,
                guardarExitoso: false,
                images_Corte1: [],
                images_Corte2: [],
                images_Corte3: [],
                images_Corte4: [],
                images_Corte5: [],
                images_Tip1: [],
                images_Tip2: [],
                images_Tip3: [],
                img_desc_tip1: '',
                img_desc_tip2: '',
                img_desc_tip3: '',
                allImages: [],//VARIABLE PARA ALMACENAR LAS IMAGENES
                allImagesTips: [],
                especies: [],//VARIABLE PARA LOS CARDS
                ops: [
                    { valor: 1, texto: 'Sí' },
                    { valor: 0, texto: 'No' },
                ],
                userRol: 0,
            };  
        },
        mounted() {
        this.listar();
        },
        watch: {
            
        },
        created() {
            this.listar();
        },
        computed: {
            filtered() {
                let filteredBySearch = this.datos.filter(dato => {
                    if (dato.n_comun) {
                        return dato.n_comun.toLowerCase().includes(this.search.toLowerCase()) ||
                            dato.n_cientifico.toLowerCase().includes(this.search.toLowerCase()) ||
                            dato.n_comercial.toLowerCase().includes(this.search.toLowerCase()) ||
                            dato.n_otro.toLowerCase().includes(this.search.toLowerCase()) ||
                            dato.n_opciones.toLowerCase().includes(this.search.toLowerCase());
                    } else {
                        return false;
                    }
                });

                if (this.FiltroTextura.length > 0) {
                    filteredBySearch = filteredBySearch.filter(dato =>
                        this.FiltroTextura.some(filtro => 
                            this.texturasxEspecie.some(txE => txE.oid_especie === dato.oid && txE.oid_textura === filtro)
                        )
                    );
                }

                if (this.FiltroParenquima.length > 0) {
                    filteredBySearch = filteredBySearch.filter(dato =>
                        this.FiltroParenquima.some(filtro => 
                            this.parenquimasxEspecie.some(txE => txE.oid_especie === dato.oid && txE.oid_parenquima === filtro)
                        )
                    );
                }

                if (this.FiltroPoros.length > 0) {
                    filteredBySearch = filteredBySearch.filter(dato =>
                        this.FiltroPoros.some(filtro => 
                            this.porosxEspecie.some(txE => txE.oid_especie === dato.oid && txE.oid_poro === filtro)
                        )
                    );
                }

                if (this.FiltroRadios.length > 0) {
                    filteredBySearch = filteredBySearch.filter(dato =>
                        this.FiltroRadios.some(filtro => 
                            this.radiosxEspecie.some(txE => txE.oid_especie === dato.oid && txE.oid_radio === filtro)
                        )
                    );
                }

                if (this.FiltroInclusiones.length > 0) {
                    filteredBySearch = filteredBySearch.filter(dato =>
                        this.FiltroInclusiones.some(filtro => 
                            this.inclusionesxEspecie.some(txE => txE.oid_especie === dato.oid && txE.oid_inclusion === filtro)
                        )
                    );
                }

                return filteredBySearch;
            },
            extractedName1() {
                if (!this.dato.n_cientifico) return '';

                const parts = this.dato.n_cientifico.split(',');
                const italicizedName = `${parts[0]}`;

                return `${italicizedName}`;
            },
            extractedName2() {
                if (!this.dato.n_cientifico) return '';

                const parts = this.dato.n_cientifico.split(',');
                const remainingText = parts.slice(1).join(', '); // Join remaining parts

                return `${remainingText}`;
            },
            optionsTexturas() {
                return [
                    //{ oid: null, titulo: 'Todos' }, // Opción por defecto "Todos"
                    ...this.texturas // Agregar las texturas obtenidas de la base de datos
                ];
            },
            optionsParenquimas() {
                return [
                    //{ oid: null, titulo: 'Todos' }, // Opción por defecto "Todos"
                    ...this.parenquimas // Agregar las parenquimas obtenidas de la base de datos
                ];
            },
            optionsPoros() {
                return [
                    //{ oid: null, titulo: 'Todos' }, // Opción por defecto "Todos"
                    ...this.poros // Agregar las poros obtenidas de la base de datos
                ];
            },
            optionsRadios() {
                return [
                    //{ oid: null, titulo: 'Todos' }, // Opción por defecto "Todos"
                    ...this.radios // Agregar las radios obtenidas de la base de datos
                ];
            },
            optionsInclusiones() {
                return [
                    //{ oid: null, titulo: 'Todos' }, // Opción por defecto "Todos"
                    ...this.inclusiones // Agregar las inclusiones obtenidas de la base de datos
                ];
            },
            userOid() {
            // Aquí obtén el nombre del usuario autenticado desde Vuex o desde el almacenamiento local
                const oid_usuario = localStorage.getItem('oidu');
                return oid_usuario;
            },
            rolOid() {
            // Aquí obtén el nombre del usuario autenticado desde Vuex o desde el almacenamiento local
                const oid_rol = localStorage.getItem('rolu');
                return Number(oid_rol);
            },
        },
        methods: {
            // Obtener la lista de Categiries
            async listar() {
                try {
                    const response = await axios.get('api/Especies/Listar');
                    const responseParenquima = await axios.get('api/Parenquimas/Listar');
                    const responseTextura = await axios.get('api/Texturas/Listar');
                    const responsePoros = await axios.get('api/Poros/Listar');
                    const responseRadios = await axios.get('api/Radios/Listar');
                    const responseInclusiones = await axios.get('api/Inclusiones/Listar');
                    const responseTexturaxEspecie = await axios.get('api/Especies/LisTexturaxEspecie');
                    const responseParenquimasxEspecie = await axios.get('api/Especies/LisParenquimasxEspecie');
                    const responsePorosxEspecie = await axios.get('api/Especies/LisPorosxEspecie');
                    const responseRadiosxEspecie = await axios.get('api/Especies/LisRadiosxEspecie');
                    const responseInclusionesxEspecie = await axios.get('api/Especies/LisInclusionesxEspecie');

                    this.datos = response.data;
                    this.parenquimas = responseParenquima.data;
                    this.texturas = responseTextura.data;
                    this.poros = responsePoros.data;
                    this.radios = responseRadios.data;
                    this.inclusiones = responseInclusiones.data;
                    this.texturasxEspecie = responseTexturaxEspecie.data;
                    this.parenquimasxEspecie = responseParenquimasxEspecie.data;
                    this.porosxEspecie = responsePorosxEspecie.data;
                    this.radiosxEspecie = responseRadiosxEspecie.data;
                    this.inclusionesxEspecie = responseInclusionesxEspecie.data;

                    const especiesData = response.data;

                    // Iterar sobre cada especie para obtener sus imágenes
                    for (let especie of especiesData) {
                        const responseImg = await axios.get(`api/BodegaImgs/ListarImagenes/${especie.oid}`);
                        especie.images = responseImg.data.map(image => ({
                            //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${especie.n_comun}/${image.nombre}`,
                            src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${especie.n_comun}/${image.nombre}`,
                            alt: image.nombre
                        }));
                    }

                    this.especies = especiesData;

                } catch (error) {
                    console.error(error);
                }
            },
            // Mostrar detalles de un ESPECIE
            async mostrar(id) {            
                try {
                    const response = await axios.get(`api/Especies/Mostrar/${id}`);
                    this.dato = response.data;
                    const nombreComun = this.dato.n_comun;

                    const responseImg = await axios.get(`api/BodegaImgs/ListarImagenes/${id}`);

                    // Initialize images_Corte arrays
                    this.images_Tip1 = [];
                    this.images_Tip2 = [];
                    this.images_Tip3 = [];

                    /*
                    const images_Tip1  = responseImg.data
                            .filter(image => image.tip === 1)
                            .map(image => `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`);
                            //.map(image => `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`);
                    this.images_Tip1 = images_Tip1.length > 0 ? images_Tip1[0] : '';                

                    const images_Tip2  = responseImg.data
                            .filter(image => image.tip === 2)
                            .map(image => `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`);
                            //.map(image => `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`);
                    this.images_Tip2 = images_Tip2.length > 0 ? images_Tip2[0] : '';
                    const images_Tip3  = responseImg.data
                            .filter(image => image.tip === 3)
                            .map(image => `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`);
                            //.map(image => `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`);
                    this.images_Tip3 = images_Tip3.length > 0 ? images_Tip3[0] : '';*/

                    const img_desc_tip1 = responseImg.data.filter(image => image.tip === 1).map(image => image.obs);
                    this.img_desc_tip1 = img_desc_tip1.length > 0 ? img_desc_tip1[0] : '';
                    const img_desc_tip2 = responseImg.data.filter(image => image.tip === 2).map(image => image.obs);
                    this.img_desc_tip2 = img_desc_tip2.length > 0 ? img_desc_tip2[0] : '';
                    const img_desc_tip3 = responseImg.data.filter(image => image.tip === 3).map(image => image.obs);
                    this.img_desc_tip3 = img_desc_tip3.length > 0 ? img_desc_tip3[0] : '';

                    if (responseImg.data && responseImg.data.length > 0) {
                        this.images_Tip1 = responseImg.data
                            .filter(image => image.tipo_corte === 6 && image.tip === 1)
                            .map(image => ({
                                //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`,
                                src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                                alt: image.nombre,
                                label: this.img_desc_tip1
                            }));

                        this.images_Tip2 = responseImg.data
                            .filter(image => image.tipo_corte === 6 && image.tip === 2)
                            .map(image => ({
                                //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`,
                                src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                                alt: image.nombre,
                                label: this.img_desc_tip2
                            }));

                        this.images_Tip3 = responseImg.data
                            .filter(image => image.tipo_corte === 6 && image.tip === 3)
                            .map(image => ({
                                //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${image.nombre}`,
                                src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                                alt: image.nombre,
                                label: this.img_desc_tip3
                            }));
                    }

                    // Initialize images_Corte arrays
                    this.images_Corte1 = [];
                    this.images_Corte2 = [];
                    this.images_Corte3 = [];
                    this.images_Corte4 = [];
                    this.images_Corte5 = [];

                    if (responseImg.data && responseImg.data.length > 0) {
                        this.images_Corte1 = responseImg.data
                            .filter(image => image.tipo_corte === 1)
                            .map(image => ({
                                //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                                src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                                alt: image.nombre,
                                label: this.getImageLabel(image.tipo_corte)
                            }));

                        this.images_Corte2 = responseImg.data
                            .filter(image => image.tipo_corte === 2)
                            .map(image => ({
                                //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                                src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                                alt: image.nombre,
                                label: this.getImageLabel(image.tipo_corte)
                            }));

                        this.images_Corte3 = responseImg.data
                            .filter(image => image.tipo_corte === 3)
                            .map(image => ({
                                //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                                src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                                alt: image.nombre,
                                label: this.getImageLabel(image.tipo_corte)
                            }));

                        this.images_Corte4 = responseImg.data
                            .filter(image => image.tipo_corte === 4)
                            .map(image => ({
                                //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                                src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                                alt: image.nombre,
                                label: this.getImageLabel(image.tipo_corte)
                            }));

                        this.images_Corte5 = responseImg.data
                            .filter(image => image.tipo_corte === 5)
                            .map(image => ({
                                //src: `https://localhost:7027/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                                src: `https://testidmaderasback.rocol.org/api/BodegaImgs/MostrarImg/${nombreComun}/${encodeURIComponent(image.nombre)}`,
                                alt: image.nombre,
                                label: this.getImageLabel(image.tipo_corte)
                            }));
                    }

                    // Concatenate the image arrays in the desired order
                    this.allImages = [
                        ...this.images_Corte1,
                        ...this.images_Corte2,
                        ...this.images_Corte3,
                        ...this.images_Corte4,
                        ...this.images_Corte5
                    ];

                    // Concatenate the image arrays in the desired order
                    this.allImagesTips = [
                        ...this.images_Tip1,
                        ...this.images_Tip2,
                        ...this.images_Tip3,
                    ];

                    this.dialogdetail = true;
                } catch (error) {
                    console.error(error);
                }
            },
            // Limpiar filtros
            limpiarFiltros() {
                this.FiltroPoros = [];
                this.FiltroParenquima = [];
                this.FiltroRadios = [];
                this.FiltroTextura = [];
                this.FiltroInclusiones = [];
                this.search = ''; // Limpiar el campo de búsqueda también, si deseas
            },
            //FUNCION PARA ASIGNAR LAS IMAGENES AL CAROUSEL
            getImageLabel(tipoCorte) {
                switch (tipoCorte) {
                    case 1:
                        return 'Corte transversal 10x';
                    case 2:
                        return 'Corte transversal 20x';
                    case 3:
                        return 'Corte transversal 10x o 20x (con dibujos de características claves)';
                    case 4:
                        return 'Corte tangencial';
                    case 5:
                        return 'Corte radial';
                    case 6:
                        return 'Tips';
                    default:
                        return 'Imagen';
                }
            },
            consultarAprobado(variable) {
                if (this.dato[variable] === 1) {
                    return { texto: 'Si'};
                }
                return { texto: 'No'};
            },        
            // Abrir el diálogo para crear una nueva área
            nueva() {
                this.dato = { oid: 0, n_comun: "", n_cientifico: "", n_comercial: "", n_otro: "", sinonimo: "", color: "", olor: "", sabor: "", veteado: "", porosidad: "", familia: "", estado: null, desc_estado: "", autor: "", n_opciones: "", };
                this.isNew = true;
                this.formTitle = 'Nueva Especie';
                this.dialog = true;
            },
            // Abrir el diálogo para editar un área existente
            async editar(dato) {
                const responseImg = await axios.get(`api/BodegaImgs/ListarImagenes/${dato.oid}`);
                const images = responseImg.data;

                // Filtra y asigna las texturas asociadas a la especie actual
                const texturaIds = this.texturasxEspecie
                    .filter(tex => tex.oid_especie === dato.oid)
                    .map(tex => tex.oid_textura);
                const parenquimaIds = this.parenquimasxEspecie
                    .filter(tex => tex.oid_especie === dato.oid)
                    .map(tex => tex.oid_parenquima);
                const porosIds = this.porosxEspecie
                    .filter(tex => tex.oid_especie === dato.oid)
                    .map(tex => tex.oid_poro);
                const radiosIds = this.radiosxEspecie
                    .filter(tex => tex.oid_especie === dato.oid)
                    .map(tex => tex.oid_radio);
                const inclusionesIds = this.inclusionesxEspecie
                    .filter(tex => tex.oid_especie === dato.oid)
                    .map(tex => tex.oid_inclusion);
                    
                this.dato = { 
                    ...dato,
                    texturas: texturaIds, // Asegúrate de inicializar texturas con IDs
                    parenquimas: parenquimaIds,
                    poros: porosIds,
                    radios: radiosIds,
                    inclusiones: inclusionesIds,
                    Corte1Name: images.find(img => img.tipo_corte === 1)?.nombre || '',
                    Corte2Name: images.find(img => img.tipo_corte === 2)?.nombre || '',
                    Corte3Name: images.find(img => img.tipo_corte === 3)?.nombre || '',
                    Corte4Name: images.find(img => img.tipo_corte === 4)?.nombre || '',
                    Corte5Name: images.find(img => img.tipo_corte === 5)?.nombre || '',
                    Tip1Name: images.find(img => img.tipo_corte === 6 && img.tip === 1)?.nombre || '',
                    Tip2Name: images.find(img => img.tipo_corte === 6 && img.tip === 2)?.nombre || '',
                    Tip3Name: images.find(img => img.tipo_corte === 6 && img.tip === 3)?.nombre || '',

                };
                this.isNew = false;
                this.formTitle = 'Actualizar Especie';
                this.dialog = true;
            },
            //REGISTRAR O ACTUALIZAR
            async guardar() {
                this.dialog_guardando = true;
                    try {
                        const payload = {
                            ...this.dato,
                            texturas: this.dato.texturas,
                            parenquimas: this.dato.parenquimas,
                            poros: this.dato.poros,
                            radios: this.dato.radios,
                            inclusiones: this.dato.inclusiones,
                        };
                        
                        let oid_especie;
                        if (this.isNew) {
                            // Crear el área
                            const respuestaCrear = await axios.post('api/Especies/Crear', payload);
                            oid_especie = respuestaCrear.data.oid;
                        } else {
                            // Actualizar el área
                            await axios.put(`api/Especies/Actualizar`, payload);
                            oid_especie = this.dato.oid;
                        }

                        // Función para enviar imágenes a la API
                        const enviarImagenes = async (imagenes, tipo_corte) => {
                                const formData = new FormData();
                                formData.append('oid_especie', oid_especie);
                                formData.append('tipo_corte', tipo_corte);
                                formData.append('Imagenes', imagenes);

                                await axios.post('api/BodegaImgs/SubirImagenes', formData);
                        };

                        const enviarImagenesTip = async (imagenes2, tip, desc) => {
                                const formData2 = new FormData();
                                formData2.append('oid_especie', oid_especie);
                                formData2.append('tip', tip);
                                formData2.append('obs', desc);
                                formData2.append('Imagenes2', imagenes2);

                                await axios.post('api/BodegaImgs/SubirTips', formData2);
                        };

                        // Enviar imágenes para cada tipo de corte
                        /*
                        await enviarImagenes(this.dato.Corte1, 1);
                        await enviarImagenes(this.dato.Corte2, 2);
                        await enviarImagenes(this.dato.Corte3, 3);
                        await enviarImagenes(this.dato.Corte4, 4);
                        await enviarImagenes(this.dato.Corte5, 5);*/

                        if (this.dato.Corte1 != null) {
                            await enviarImagenes(this.dato.Corte1, 1);
                        }
                        if (this.dato.Corte2 != null) {
                            await enviarImagenes(this.dato.Corte2, 2);
                        }
                        if (this.dato.Corte3 != null) {
                            await enviarImagenes(this.dato.Corte3, 3);
                        }
                        if (this.dato.Corte4 != null) {
                            await enviarImagenes(this.dato.Corte4, 4);
                        }
                        if (this.dato.Corte5 != null) {
                            await enviarImagenes(this.dato.Corte5, 5);
                        }

                        if (this.dato.Tip1 != null) {
                            await enviarImagenesTip(this.dato.Tip1, 1, this.dato.desc_tip1);
                        }
                        if (this.dato.Tip2 != null) {
                            await enviarImagenesTip(this.dato.Tip2, 2, this.dato.desc_tip2);
                        }
                        if (this.dato.Tip3 != null) {
                            await enviarImagenesTip(this.dato.Tip3, 3, this.dato.desc_tip3);
                        }

                        /*await enviarImagenesTip(this.dato.Tip1, 1, this.dato.desc_tip1);
                        await enviarImagenesTip(this.dato.Tip2, 2, this.dato.desc_tip2);
                        await enviarImagenesTip(this.dato.Tip3, 3, this.dato.desc_tip3);*/

                        // Limpiar el formulario
                        this.dato = { oid: 0, n_comun: '', n_cientifico: '', n_comercial: '', n_otro: '', sinonimo: '', color: '', olor: '', sabor: '', veteado: '', porosidad: '', Corte1: [], Corte2: [], Corte3: [], Corte4: [], Corte5: [], Tip1: [], Tip2: [], Tip3: [], autor: '', n_opciones: '',};

                        // Después de guardar exitosamente el registro:
                        this.guardarExitoso = true;
                        this.dialog = false;
                        await this.listar();
                        
                    } catch (error) {
                        console.error(error);
                    } finally {
                        // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                        this.dialog_guardando = false;
                    }
            },
            // Eliminar un área
            async eliminar(id) {          
                try {
                    await axios.delete(`api/Especies/Eliminar/${id}`);
                    this.guardarExitoso = true;
                    this.listar();
                    this.cancelarEliminar();
                } catch (error) {
                    console.error(error);
                } 
            },
            // Confirmar eliminación de un área
            confirmarEliminar(id) {
                this.confirmItemId = id;
                this.showConfirmDialog = true;
            },
            // Cancelar eliminación
            cancelarEliminar() {
                this.confirmItemId = null;
                this.showConfirmDialog = false;
            },        
            // Cancelar Detalle
            cancelarDetalle() {
                this.dialogdetail = false;            
            },
            cerrar() {
                this.dialog = false;
            },
            validarR1(value) {
                return value ? true : 'Este campo es obligatorio para registrar la especie';
            },
        },
        
    };
</script>
<style scoped>
    .v-card {
        perspective: 1000px;
        transition: transform 0.5s;
    }

    .v-card.is-flipped {
        transform: rotateY(180deg);
    }

    .custom-h1 {
        font-size: 2.5em; /* Puedes ajustar el tamaño según tus necesidades */
        font-weight: bold; /* Otras propiedades de estilo si es necesario */
    }

    .custom-h3 {
        font-size: 1.5em; /* Puedes ajustar el tamaño según tus necesidades */  
    }
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    .p1{
        font-size: 17px; 
        color: rgb(15, 135, 201); 
        line-height: 1em;
    }    
    details { 
        background-color: #f6f8fa;
        width: 100%;
        margin-bottom: 1rem;   
        border-radius: 8px;  
        border: 1px solid #d8e0e9;
        color: #364f6b;
        position: relative;  
        padding-top: 0px;
    }
    details[open] summary {
        border-bottom: 1px solid #aaa;
        margin-bottom: 0.5em;
    }
    details summary {  
        font-weight: 400;
        font-size: 1.25rem;
        padding: 1rem;
        cursor: pointer;
        list-style: none;
    }
    details summary::before {
        content: "▶"; /* Flecha hacia la derecha */
        font-size: 1.5rem;
        line-height: 1.5rem;
        color: #364f6b;
        position: absolute;
        left: 97%; /* Ajusta el espacio entre la flecha y el texto */
    }
    details[open] summary::before {
        content: "▼"; /* Flecha hacia abajo cuando details está abierto */
    }
    .fixed {
        position: sticky;
        top: 0;
        z-index: 1;
        background-color: white; /* Asegúrate de que el fondo sea el mismo que el contenedor */
    }
    
    /* CAROUSEL MAS DINAMICO */
    .overlay-carousel .v-carousel-item {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        transition: opacity 0.5s ease-in-out;
        opacity: 0;
    }

    .overlay-carousel .v-carousel-item.v-window-item--active {
        opacity: 1;
        position: absolute;
    }

    .v-carousel .v-window {
        position: relative;
        height: 100%;
    }

    .fade-transition {
        transition: opacity 0.5s ease-in-out;
    }

    /*ESTILOS PARA FIJAR Y COLOREAR */
    .sticky {
        position: -webkit-sticky;
        position: sticky;
        background: white;
        z-index: 2;
    }

    .sticky-left {
        left: 0;
        z-index: 3;
    }

    .sticky-left-2 {
        left: 80px; /* Ajusta este valor dependiendo del ancho de tu primera columna */
        z-index: 3;
    }

    .sticky-left-3 {
        left: 170px; /* Ajusta este valor dependiendo del ancho de tus primeras dos columnas */
        z-index: 3;
    }

    .row-white {
        background-color: white !important;
    }

    .row-gray {
        background-color: #f5f5f5 !important; /* Color gris claro */
    }
</style>